import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'src/app/services/functions/auth/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const serviceAuth = inject(AuthService);
  const router = inject(Router);
  const token = serviceAuth.getToken();

  if (token) { return true; } else {
    router.navigate(['external/login']);
    return false;
  }
};
